module.exports = __webpack_public_path__ + "img/3.7bbad7a6.jpg";